<template>
	<Modal @close="$emit('close')" size="large">
		<div class="container">

			<div class="row">
				<div class="col-12">
					<h3>{{person.name}} History</h3>
				</div>
			</div>

			<div class="row">
				<div class="col-6">
					<router-link target="_blank" :to="params" class="button-action">Print</router-link>
				</div>
			</div>

			<p id="noHistory" v-if="!personHistory.length">No history found</p>
			<table v-if="personHistory.length" class="item-table history-table">
				<thead>
					<tr class="item-headers">
						<th>
							<div class="bar bg-blue">
								<h3>Date</h3>
							</div>
						</th>
						<th>
							<div class="bar bg-brown">
								<h3>Name</h3>
							</div> 
						</th>
						<th>
							<div class="bar bg-brown">
								<h3>Lot</h3>
							</div> 
						</th>
						<th>
							<div class="bar bg-brown">
								<h3>Tasks</h3>
							</div> 
						</th>
					</tr>
				</thead>

				<tbody>
					<tr v-for="(history, index) in personHistory" :key="index">
						<td>{{formatDate(history.date.split('T')[0])}}</td>
						<td>{{history.name ? history.name : ''}}</td>
						<td>{{history.lot_num ? history.lot_num : ''}}</td>
						<td>{{history.tasks}}</td>
					</tr>
				</tbody>
			</table>

		</div>
	</Modal>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import Modal from './../Modal.vue'
import history from '../../lib/history';

export default {
	components: {
		Modal
	},
	data() {
		return {
			personHistory: {},
			params: '/print/person'
		}
	},
	props: [
		'person'
	],
	methods: {
		print() {
			window.print();
		},
		formatDate(date) {
			return moment(date).format('DD/MM/YYYY')
		}
	},
	mounted() {
		this.params = this.params + `/${this.$props.person.name}` + `/${this.$props.person.id}`
		this.$store.commit('app/setLoading', true)
		history.person(this.$props.person.id)
		.then(res => {
			this.$store.commit('app/setLoading', false);
			this.personHistory = res
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">
@import '../../scss/variables.scss';
#noHistory {
	color: $error_color;
	font-weight: 600;
}
.history-table {
	tr {
		h3 {
			color: white !important;
			font-weight: bold !important;
			font-size: 18px !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/People/History.vue